function w(u) {
  let m = ".", f = "__", r = "--", b;
  if (u) {
    let e = u.blockPrefix;
    e && (m = e), e = u.elementPrefix, e && (f = e), e = u.modifierPrefix, e && (r = e);
  }
  const s = {
    install(e) {
      b = e.c;
      const n = e.context;
      n.bem = {}, n.bem.b = null, n.bem.els = null;
    }
  };
  function $(e) {
    let n, l;
    return {
      before(i) {
        n = i.bem.b, l = i.bem.els, i.bem.els = null;
      },
      after(i) {
        i.bem.b = n, i.bem.els = l;
      },
      $({ context: i, props: t }) {
        return e = typeof e == "string" ? e : e({ context: i, props: t }), i.bem.b = e, `${(t == null ? void 0 : t.bPrefix) || m}${i.bem.b}`;
      }
    };
  }
  function c(e) {
    let n;
    return {
      before(l) {
        n = l.bem.els;
      },
      after(l) {
        l.bem.els = n;
      },
      $({ context: l, props: i }) {
        return e = typeof e == "string" ? e : e({ context: l, props: i }), l.bem.els = e.split(",").map((t) => t.trim()), l.bem.els.map((t) => `${(i == null ? void 0 : i.bPrefix) || m}${l.bem.b}${f}${t}`).join(", ");
      }
    };
  }
  function v(e) {
    return {
      $({ context: n, props: l }) {
        e = typeof e == "string" ? e : e({ context: n, props: l });
        const i = e.split(",").map((o) => o.trim());
        function t(o) {
          return i.map((P) => `&${(l == null ? void 0 : l.bPrefix) || m}${n.bem.b}${o !== void 0 ? `${f}${o}` : ""}${r}${P}`).join(", ");
        }
        const d = n.bem.els;
        if (d !== null) {
          if (process.env.NODE_ENV !== "production" && d.length >= 2)
            throw Error(`[css-render/plugin-bem]: m(${e}) is invalid, using modifier inside multiple elements is not allowed`);
          return t(d[0]);
        } else
          return t();
      }
    };
  }
  function E(e) {
    return {
      $({ context: n, props: l }) {
        e = typeof e == "string" ? e : e({ context: n, props: l });
        const i = n.bem.els;
        if (process.env.NODE_ENV !== "production" && i !== null && i.length >= 2)
          throw Error(`[css-render/plugin-bem]: notM(${e}) is invalid, using modifier inside multiple elements is not allowed`);
        return `&:not(${(l == null ? void 0 : l.bPrefix) || m}${n.bem.b}${i !== null && i.length > 0 ? `${f}${i[0]}` : ""}${r}${e})`;
      }
    };
  }
  return Object.assign(s, {
    cB: (...e) => b($(e[0]), e[1], e[2]),
    cE: (...e) => b(c(e[0]), e[1], e[2]),
    cM: (...e) => b(v(e[0]), e[1], e[2]),
    cNotM: (...e) => b(E(e[0]), e[1], e[2])
  }), s;
}
export {
  w as default,
  w as plugin
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@css-render_plugin-bem@0.15.14_css-render@0.15.14/~/@css-render/plugin-bem/esm/index.js
// module id = 1344
// module chunks = 67